<template>
    <div class="pl-5 py-5 caption" >
        <v-row>
            <v-col style="max-width: 50px" class="pr-0 py-0">SP</v-col>
            <v-col style="max-width: 30px" class="pa-0">...</v-col>
            <v-col class="pa-0 text-left">Anzahl der Spiele</v-col>
        </v-row>
        <v-row>
            <v-col style="max-width: 50px" class="pr-0 py-0">S/U/N</v-col>
            <v-col style="max-width: 30px" class="pa-0">...</v-col>
            <v-col class="pa-0 text-left">Anzahl der Siege/Unentschieden/Niederlagen</v-col>
        </v-row>
        <v-row>
            <v-col style="max-width: 50px" class="pr-0 py-0">SaP</v-col>
            <v-col style="max-width: 30px" class="pa-0">...</v-col>
            <v-col class="pa-0 text-left">Satzpunkte gewonnen zu verloren
                (und die Differenz in der nächsten Spalte)</v-col>
        </v-row>
        <v-row>
            <v-col style="max-width: 50px" class="pr-0 py-0">MaP</v-col>
            <v-col style="max-width: 30px" class="pa-0">...</v-col>
            <v-col class="pa-0 text-left">Mannschaftspunkte gewonnen zu verloren
                (und die Differenz in der nächsten Spalte)</v-col>
        </v-row>
        <v-row>
            <v-col style="max-width: 50px" class="pr-0 py-0">Pkt</v-col>
            <v-col style="max-width: 30px" class="pa-0">...</v-col>
            <v-col class="pa-0 text-left">Tabellenpunkte</v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "tabelle-legend"
    }
</script>

<style scoped>

</style>